import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ChevronRight } from "lucide-react";

// Shows "Company ▸ <label>" only when a ?company=<id> param is present (staff hub navigation).
export default function CompanyBreadcrumb({ label }) {
  const [name, setName] = useState("");
  const companyId = new URLSearchParams(window.location.search).get("company");

  useEffect(() => {
    if (!companyId) return;
    api.get(`/companies/${companyId}`).then((r) => setName(r.data?.name || "")).catch(() => {});
  }, [companyId]);

  if (!companyId) return null;

  return (
    <div data-testid="company-breadcrumb" className="flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-muted-foreground mb-4">
      <Link to={`/companies/${companyId}`} className="hover:text-black transition-colors">{name || "Company"}</Link>
      <ChevronRight className="h-3 w-3" />
      <span className="text-black">{label}</span>
    </div>
  );
}
